import {booking} from "./feature.booking.svelte.js";
import {booker} from "../booker/feature.booker.svelte.js";
import * as money_util from "../../utils/MoneyUtil.js";
import * as booking_select from "./booking.scenarios.select.svelte.js";
import * as packagedeals_select from "../packagedeals/packagedeals.scenarios.select.svelte.js";
import * as products_select from "../products/products.scenarios.select.svelte.js";
import * as booking_update from "./booking.scenarios.update.svelte.js";
import AppConfig from "../../AppConfig.js";
import * as booking_update_receipt from ".//booking.scenarios.update.receipt.svelte.js";


export function calculateBookingTotals()
{
  //console.log('calculateBookingTotals start');
  let iTime = Date.now(); // voor makkelijker filteren in console 

  // verwijder eerst eventuele verzekeringen om een zuivere berekening te krijgen.. aan het einde voegen we de verzekering indien nodig weer toe
  booking_update.removeInsurancesForEveryone();

  // booking_select.updateBookingSummary(); // zou niet meer nodig moeten zijn ivm booking_actions.handleBookingUpdated();

  const oBooking = booking.oBookingSummary;

  //window.console.log('booking->calculateBookingTotals', {oBooking});

  let bHasErrors = false;
  let iSubTotalYourStayCents = 0;
  let iDeltaPackageDealCents = 0;
  let iDeltaTreatmentsCents = 0;
  let iDeltaFormCents = 0;
  let aSubtotalPerPerson = [];

  for ( const oPerson of oBooking.aPeople )
  {
    booking_update_receipt.debugCalculation(iTime, '== BEGIN VERWERKING PERSOON ==');
    let iSubtotalPerson = 0;
    let iPackageDealID = 0;

    for ( const oPackageDealConfig of oPerson.aBookedPackageDeals )
    {

      iPackageDealID = oPackageDealConfig.iID;
      if ( bHasErrors ) break;

      const oPackageDeal = packagedeals_select.getPackageDealByID(iPackageDealID);

      if ( oPackageDeal )
      {
        let oPackageDealInfoForDate = packagedeals_select.getPackageDealInfoForLastProcessedDate(iPackageDealID);
        booking_update_receipt.debugCalculation(iTime, 'Er is een arrangement gekozen.');

        const sDateUsedForPackageDealInfo = oPackageDealInfoForDate.sDateUsed;
        if ( !sDateUsedForPackageDealInfo || sDateUsedForPackageDealInfo !== booking.sArrivalDate )
        {// "2018-07-03" - "29-07-2018"
          booking_update_receipt.debugCalculation(iTime, 'Er is een arrangement gekozen maar de prijsdata in de store is van een andere datum!', sDateUsedForPackageDealInfo, booking.sArrivalDate);
          bHasErrors = true;
        }
        else
        {

          iSubtotalPerson += oPackageDealInfoForDate.iPrice;
          iDeltaPackageDealCents += oPackageDealInfoForDate.iPrice;
        }
      }
      else
      {
        booking_update_receipt.debugCalculation(iTime, 'Er is een arrangement gekozen, maar die kan niet meer gevonden worden.');
        bHasErrors = true;
      }
    }
    // producten in arrangement
    for ( const iBuyableID of oPerson.aAllBookedProductIDs )
    {
      if ( !oPerson.aBookedProductIDsWithoutPackageDeal.includes(iBuyableID) )
      {// dit is een product dat onderdeel is van een arrangement
        const oProductInPackageDeal = packagedeals_select.getProductInPackageDeal(iPackageDealID, iBuyableID);

        if ( oProductInPackageDeal )
        {
          const iAdditionalCosts = oProductInPackageDeal.iAdditionalCosts || 0;
          booking_update_receipt.debugCalculation(iTime, 'We hebben product ' + iBuyableID + ' bij arrangement ' + iPackageDealID + ' met een added cost van ' + iAdditionalCosts);
          iSubtotalPerson += iAdditionalCosts;
          iDeltaPackageDealCents += iAdditionalCosts;
        }
        else
        {
          booking_update_receipt.debugCalculation(iTime, 'Product ' + iBuyableID + ' bij arrangement ' + iPackageDealID + ' kan niet gevonden worden in de productcatalogus.');
          bHasErrors = true;
        }
      }
      else
      {// dit is een product buiten een arrangement
        const oProduct = products_select.getProductByID(iBuyableID);
        if ( oProduct )
        {
          const iPrice = oProduct.iPrice;
          iSubtotalPerson += iPrice;
          booking_update_receipt.debugCalculation(iTime, 'Product ' + iBuyableID + ' zonder arr kost ', iPrice, ' wat het subtotaal van de persoon nu brengt op ', iSubtotalPerson);

          if ( oProduct.bIsEntry )
          {
            iSubTotalYourStayCents += iPrice;
          }
          else
          {
            iDeltaTreatmentsCents += iPrice;
          }
        }
        else
        {
          bHasErrors = true;
        }
      }
    }

    aSubtotalPerPerson.push({iCents: iSubtotalPerson});
  }

  booking_update_receipt.debugCalculation(iTime, 'Alle personen zijn verwerkt. Zijn er errors?', bHasErrors);

  if ( bHasErrors )
  {
    booking.mTotals.bWereTotalsErrorFree = false;
    iSubTotalYourStayCents = 0;
    iDeltaPackageDealCents = 0;
    iDeltaTreatmentsCents = 0;
    iDeltaFormCents = 0;
  }
  else
  {
    booking.mTotals.bWereTotalsErrorFree = true;
  }

  booking_update_receipt.debugCalculation(iTime, 'mSubTotalYourStay', iSubTotalYourStayCents, money_util.centsToFriendly(iSubTotalYourStayCents));

  booking.mTotals.mSubTotalYourStay = {
    iCents: iSubTotalYourStayCents,
    mFriendly: money_util.centsToFriendly(iSubTotalYourStayCents)
  };

  const iSubtotalPackageDeal = iSubTotalYourStayCents + iDeltaPackageDealCents;

  booking_update_receipt.debugCalculation(iTime, 'mSubTotalPackageDeal', iSubtotalPackageDeal, money_util.centsToFriendly(iSubtotalPackageDeal));

  booking.mTotals.mSubTotalPackageDeal = {
    iCents: iSubtotalPackageDeal,
    mFriendly: money_util.centsToFriendly(iSubtotalPackageDeal)
  };

  const iSubtotalTreatments = iSubTotalYourStayCents + iDeltaPackageDealCents + iDeltaTreatmentsCents;
  booking_update_receipt.debugCalculation(iTime, 'mSubTotalTreatments', iSubtotalTreatments, money_util.centsToFriendly(iSubtotalTreatments));
  booking.mTotals.mSubTotalTreatments = {
    iCents: iSubtotalTreatments,
    mFriendly: money_util.centsToFriendly(iSubtotalTreatments)
  };

  const iTotalCentsExInsurance = iSubTotalYourStayCents + iDeltaPackageDealCents + iDeltaTreatmentsCents + iDeltaFormCents;
  booking_update_receipt.debugCalculation(iTime, 'mSubTotalForm', iTotalCentsExInsurance, money_util.centsToFriendly(iTotalCentsExInsurance));
  booking.mTotals.mSubTotalForm = {
    iCents: iTotalCentsExInsurance,
    mFriendly: money_util.centsToFriendly(iTotalCentsExInsurance)
  };

  // Het type verzekeringen is 1 op 1 afhankelijk van het totaalbedrag. Het veranderen van een verzekeringsproduct kan
  // daardoor direct hier ipv op een hoger niveau.
  // Aan het begin van deze functie hebben we alle verzekeringen verwijderd om een zuivere berekening van de totalen te krijgen.

  // Wil men een verzekering?
  let iInsuranceAddedCosts = 0;
  const bWantsInsurance = booker.bInsurance;

  if ( bWantsInsurance )
  {
    booking_update_receipt.debugCalculation(iTime, 'De wens is om verzekering toe te voegen.');

    //Insurance en badenkaart kan niet samen
    booking_update.resetBadenkaart();

    // goede toevoegen bij persoon 1 - we doen dat in deze functie omdat het verzekeringsproduct steeds moet worden veranderd
    // op basis van het totaalbedrag van de boeking zonder de verzekeringsprijs
    const iInsuranceBuyableID = booking_select.getAppropriateInsuranceProductID();

    if ( iInsuranceBuyableID )
    {
      //booking_update.addProductToPerson(booking.lPeople[0].sID, iInsuranceBuyableID);
      const oFirstPerson = booking_select.getFirstPerson();

      if ( oFirstPerson )
      {
        booking_update.addProductToPerson(booking.lPeople[0].sID, iInsuranceBuyableID);

        // na toevoegen weer ophalen om zeker te weten dat het -echt- in de order zit
        const iCurrentInsuranceProductID = booking_select.getCurrentInsuranceProductIDBookedForPerson(booking.lPeople[0].sID);

        if ( iCurrentInsuranceProductID )
        {
          const oInsuranceProduct = products_select.getProductByID(iCurrentInsuranceProductID);

          if ( oInsuranceProduct )
          {
            iInsuranceAddedCosts = oInsuranceProduct.iPrice;
//console.log('iDeltaInsuranceCents:', iInsuranceAddedCosts);
          }
        }
      }
    }
  }

  let iTotalCentsIncInsurance = iTotalCentsExInsurance + iInsuranceAddedCosts;
  // let iTotalCentsIncInsurance = 0;

  booking_update_receipt.debugCalculation(iTime, 'mTotal', iTotalCentsIncInsurance, money_util.centsToFriendly(iTotalCentsIncInsurance));

  booking.mTotals.mTotal = {
    iCents: iTotalCentsIncInsurance,
    mFriendly: money_util.centsToFriendly(iTotalCentsIncInsurance)
  };

  booking.mTotals.mTotalBeforeDiscountsAndCoupons = {
    iCents: iTotalCentsIncInsurance,
    mFriendly: money_util.centsToFriendly(iTotalCentsIncInsurance)
  };

  //Eventuele cadeaubonnen verrekenen
  let iCentsDiscountGiftcardVouchers = 0;

  const aValidGiftcardCodes = booking.lValidGiftcardCodes;

  aValidGiftcardCodes.forEach((oGiftcard, index) => {
    const iGiftcardValueCents = oGiftcard.iValueCents;
    iCentsDiscountGiftcardVouchers += iGiftcardValueCents;
  });

  let iTotalCentsExGiftcard = iTotalCentsIncInsurance;
  let iTotalCentsIncGiftcard = iTotalCentsIncInsurance;

  if ( iTotalCentsIncInsurance >= iCentsDiscountGiftcardVouchers )
  {
    iTotalCentsIncGiftcard = iTotalCentsExGiftcard - iCentsDiscountGiftcardVouchers;
  }
  else
  {
    // je mag tegenwoordig wel meer vouchers inleggen dan nodig
    iTotalCentsIncGiftcard = 0;
  }

  let iTotalCentsIncGiftcardAndBadenkaart = iTotalCentsIncGiftcard;

  // const aValidBadenkaartCodes = booking.lValidBadenkaartCodes;
  // aValidBadenkaartCodes.forEach((oBadenkaart, index) => {
  //   const iBadenkaartValueCents = oBadenkaart.iValueCents;
  //   iTotalCentsIncGiftcardAndBadenkaart -= iBadenkaartValueCents;
  // });
  //
  // if ( iTotalCentsIncGiftcardAndBadenkaart < 0 )
  // {
  //   booking_update.resetBadenkaart();
  // }

  booking_update_receipt.debugCalculation(iTime, 'mTotal na giftcards en badenkaart', iTotalCentsIncGiftcardAndBadenkaart, money_util.centsToFriendly(iTotalCentsIncGiftcardAndBadenkaart));

  booking.mTotals.mTotal = {
    iCents: iTotalCentsIncGiftcardAndBadenkaart,
    mFriendly: money_util.centsToFriendly(iTotalCentsIncGiftcardAndBadenkaart)
  };
}

export function debugCalculation(...sMessage)
{
  if ( AppConfig.bLogCalculateTotalsStepsToConsole !== true )
  {
    return;
  }

  window.console.log("calculation", ...sMessage);
}
